module.exports = __webpack_public_path__ + "img/blue_leather_jacket-120x156.30281a2d.jpg";